import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ArrowRight, Compass } from 'lucide-react'
import { ROUTES } from '@/lib/constants'

export default function NotFound() {
  const { t } = useTranslation('common')

  return (
    <>
      <Helmet>
        <title>{`${t('notFound.title')} | Tdrem`}</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <section className="container flex min-h-[60vh] flex-col items-center justify-center py-24 text-center">
        <span className="mb-6 inline-flex h-16 w-16 items-center justify-center rounded-2xl bg-primary/10 text-primary">
          <Compass className="h-8 w-8" />
        </span>
        <p className="text-sm font-semibold text-primary">404</p>
        <h1 className="mt-2 text-3xl font-bold md:text-4xl">{t('notFound.title')}</h1>
        <p className="mt-3 max-w-md text-muted-foreground">{t('notFound.description')}</p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link to={ROUTES.HOME} className="inline-flex h-11 items-center rounded-xl bg-primary px-5 font-medium text-primary-foreground">
            {t('notFound.cta')}
          </Link>
          <Link to={ROUTES.PRODUCTS} className="inline-flex h-11 items-center gap-2 rounded-xl border px-5 font-medium hover:bg-accent">
            {t('nav.allProducts')}
            <ArrowRight className="h-4 w-4 flip-rtl" />
          </Link>
        </div>
      </section>
    </>
  )
}
